(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trapFocus;
// used https://hidde.blog/using-javascript-to-trap-focus-in-an-element/ as reference

function trapFocus(container, targetElement, closeElement) {
  const focusableEls = container.find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]),' + ' input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];
  const KEYCODE_ESC = 27;
  const KEYCODE_TAB = 9;

  // set focus on first focusable element
  setTimeout(function () {
    firstFocusableEl.focus();
  }, 1);
  closeElement.on('click', function (e) {
    targetElement.focus();
  });
  container.on('keydown', function (e) {
    const isEscPressed = e.key === 'Esc' || e.keyCode === KEYCODE_ESC;
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (e.shiftKey && isTabPressed) /* shift + tab */{
        if (firstFocusableEl === document.activeElement) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      } else if (isTabPressed) /* tab */{
        if (lastFocusableEl === document.activeElement) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }

    // close container element
    if (isEscPressed) {
      closeElement.click();
      targetElement.focus();
    }
  });
}

},{}],2:[function(require,module,exports){
"use strict";

var _utils = _interopRequireDefault(require("./utils"));
var _focusTrap = _interopRequireDefault(require("./focus-trap"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 .js-myk- classes kept for compatibility. Will be removed in future version
 */
const navBarElement = $('.js-myk-navbar, .js-header-basic-navbar');
const toggleButtonElement = $('.js-navbar-toggler-dropdown');
const closeElement = $('.js-myk-navbar .js-myk-navbar-close, .js-header-basic-navbar .js-header-basic-navbar-close');
if ((0, _utils.default)('js-myk-navbar') || (0, _utils.default)('js-header-basic-navbar')) {
  toggleButtonElement.on('click', function () {
    (0, _focusTrap.default)(navBarElement, toggleButtonElement, closeElement);
  });
  $('.js-navbar-toggler-dropdown').each(function () {
    $(this).parent().on('show.bs.dropdown', function () {
      $('html').addClass('noscroll');
      if (navBarElement.hasClass('show')) {
        navBarElement.removeClass('show');
        toggleButtonElement.addClass('collapsed');
        closeElement.addClass('collapsed');
      }
    });
    $(this).parent().on('hidden.bs.dropdown', function () {
      if (toggleButtonElement.hasClass('collapsed')) {
        $('html').removeClass('noscroll');
        $('html').removeAttr('class');
      }
    });
  });

  /* trigger bootstrap dropdown show/hide functionality via click on backdrop */
  $('body').on('click', 'js-header-basic-menu-backdrop,.js-myk-menu-backdrop', function () {
    if (navBarElement.hasClass('show')) {
      navBarElement.removeClass('show');
    }
  });
}

},{"./focus-trap":1,"./utils":10}],3:[function(require,module,exports){
"use strict";

var _utils = _interopRequireDefault(require("./utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* PASSWORD FIELD */

if ((0, _utils.default)('js-input-group-password')) {
  // Get all password elements from document by class names.
  const allPasswordElements = document.getElementsByClassName('js-input-group-password');

  // Loop through all objects retrieved from document and add eventListeners to each one.
  for (const element of allPasswordElements) {
    const passwordBtn = element.querySelector('.js-btn-form-password');
    passwordBtn.addEventListener('click', function () {
      const inputField = element.querySelector('.js-form-control-password');
      const iconVisible = element.querySelector('.js-btn-form-password-icon-visible');
      const iconHidden = element.querySelector('.js-btn-form-password-icon-hidden');

      // Switch input types from/to password/text according to current type & switch button icons accordingly
      if (inputField.type === 'password') {
        inputField.type = 'text';
        hideElement(iconVisible);
        showElement(iconHidden);
      } else {
        inputField.type = 'password';
        hideElement(iconHidden);
        showElement(iconVisible);
      }
    });
  }
  function showElement(ele) {
    ele.classList.remove('d-none');
    ele.classList.add('d-inline');
  }
  function hideElement(ele) {
    ele.classList.remove('d-inline');
    ele.classList.add('d-none');
  }
}

},{"./utils":10}],4:[function(require,module,exports){
"use strict";

require("./input-group-password");
require("./header-basic-menu-mobile");
var _menu = _interopRequireDefault(require("./menu"));
require("./menu-mobile");
require("./myk-menu");
require("./kadaster-menu");
var _menuMobileSearch = _interopRequireDefault(require("./menu-mobile-search"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* MENU */
(0, _menu.default)();
$(function () {
  /* MOBILE MENU */
  const mobileMenu = document.querySelector('.header-mobile .menu');
  if (mobileMenu) {
    new _menuMobileSearch.default(mobileMenu);
  }
  $('#menu-mobile-dropdown-menu-container').menuMobile();

  /* TOGGLETIP */

  // Function to get a sibling element if it matches a given selector
  // Return first next sibling if no selector is provided
  function getNextSibling(elem, selector) {
    // Get the next sibling element
    let sibling = elem.nextElementSibling;

    // If there's no selector, return the first sibling
    if (!selector) return sibling;

    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
      if (sibling.matches(selector)) return sibling;
      sibling = sibling.nextElementSibling;
    }
  }
  ;

  // Get all the toggletip buttons (focusable elements)
  const toggletips = document.querySelectorAll('.js-toggletip-button');

  // Iterate over them
  Array.prototype.forEach.call(toggletips, function (toggletip) {
    const caret = toggletip.getElementsByClassName('js-toggletip-caret')[0];
    const toggletipBubble = getNextSibling(toggletip, '.js-toggletip-bubble');
    const closeButton = toggletipBubble.querySelector('.js-toggletip-close-button');
    let previousActiveElement;
    const toggleToggletip = () => {
      toggletipBubble.classList.toggle('d-block');
      caret.classList.toggle('d-block');
    };
    const toggleToggleTipWithFocusRestored = () => {
      toggleToggletip();
      previousActiveElement.focus();
    };
    const getAllFocusableElementsInToggletip = () => {
      return [...toggletipBubble.querySelectorAll('a, button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])')].filter(el => !el.hasAttribute('disabled'));
    };

    // search for focusable elements within a context
    const getFirstFocusableElement = () => {
      const focusable = getAllFocusableElementsInToggletip();
      return focusable[0];
    };

    // Open on click, save clicked element & focus on toggleTipBubble
    toggletip.addEventListener('click', () => {
      window.setTimeout(function () {
        previousActiveElement = document.activeElement;
        toggleToggletip();
        getFirstFocusableElement().focus();
      }, 100);
    });

    // Close on outside click (EventListener is only added on pages with toggletips), restore focus to last clicked element
    document.addEventListener('click', function (e) {
      if (toggletipBubble !== e.target && toggletipBubble.classList.contains('d-block')) {
        toggleToggleTipWithFocusRestored();
      }
    });

    // Close toggletip on close button click, restore focus to last clicked element
    closeButton.addEventListener('click', function (e) {
      if (toggletipBubble !== e.target && toggletipBubble.classList.contains('d-block')) {
        toggleToggleTipWithFocusRestored();
      }
    });

    // Close on ESC., restore focus to last clicked element
    toggletip.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && toggletipBubble.classList.contains('d-block')) {
        toggleToggleTipWithFocusRestored();
      }
    });

    // code to trap focus inside toggletip and close toggletip on ESC keypress
    const focusableElementsInToggletip = getAllFocusableElementsInToggletip();
    const firstFocusableElement = getFirstFocusableElement();
    const lastFocusableElement = focusableElementsInToggletip[focusableElementsInToggletip.length - 1];
    const handleKeyDownInToggletip = event => {
      // code to trap focus inside toggletip
      if (event.key === 'Tab') {
        if (event.shiftKey) {
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      } else if (event.key === 'Escape') {
        // close toggletip on ESC keypress
        toggleToggleTipWithFocusRestored();
      }
    };
    toggletipBubble.addEventListener('keydown', handleKeyDownInToggletip);
  });
});

},{"./header-basic-menu-mobile":2,"./input-group-password":3,"./kadaster-menu":5,"./menu":8,"./menu-mobile":7,"./menu-mobile-search":6,"./myk-menu":9}],5:[function(require,module,exports){
"use strict";

var _utils = require("./utils");
/**
 * This file is being used for menu's on:
 *
 *  kadaster.nl
 *  kadaster.com
 *  oicrf.org
 *  bes.kadaster.nl
 *  nsgi.nl
 *  developer.kadaster.nl
 * bag.basisregistraties.overheid.nl
 * brk.basisregistraties.overheid.nl
 * brt.basisregistraties.overheid.nl
 * ... and (m)any other sites that use the private/business theme
 */

if ((0, _utils.needsLoadingById)('menu-mobile-dropdown-menu-container')) {
  const toggleButtonElement = $('.js-navbar-toggler-dropdown');
  const closeElement = $('.js-navbar-toggler-dropdown');
  let toggleIsOpen = false;
  toggleButtonElement.on('click', function () {
    toggleIsOpen = !toggleIsOpen;
    const menuContainer = document.getElementsByClassName('menu-mobile-dropdown-menu')[0];
    const toggleButton = [document.getElementsByClassName('js-navbar-toggler-dropdown')[0]];
    if (toggleIsOpen) {
      trapFocus(menuContainer, toggleButton, toggleButtonElement, closeElement);
    } else {
      untrapFocus();
      toggleButton[0].focus();
    }
  });
  toggleButtonElement.each(function () {
    $(this).parent().on('show.bs.dropdown', function () {
      $('html').addClass('noscroll');
      if (navBarElement.hasClass('show')) {
        navBarElement.removeClass('show');
        toggleButtonElement.addClass('collapsed');
        closeElement.addClass('collapsed');
      }
    });
    $(this).parent().on('hidden.bs.dropdown', function () {
      if (toggleButtonElement.hasClass('collapsed')) {
        $('html').removeClass('noscroll');
        $('html').removeAttr('class');
      }
    });
  });
  function untrapFocus() {
    $('body').off('keydown');
  }
  function trapFocus(container, extraFocusableElements, targetElement, closeElement) {
    const KEYCODE_ESC = 27;
    const KEYCODE_TAB = 9;
    function getFocusableElements(extraFocusableElements) {
      const focusableElements = container.querySelectorAll('a, button, textarea, input[type="text"],input[type="radio"], input[type="checkbox"], input[type="tel"], input[type="email"], select');
      const focusArray = Array.from(focusableElements).filter(el => !el.disabled).filter(el => el.offsetParent !== null || window.getComputedStyle(el).display !== 'none').filter(el => !hasInvisibleParent(el, container)).filter(el => hasVisibleMenu(el, container));
      return focusArray.concat(extraFocusableElements);
    }
    function hasInvisibleParent(element, container) {
      let el = element;
      while (el !== null && el !== container) {
        if (window.getComputedStyle(el).display === 'none') {
          return true;
        }
        el = el.parentElement;
      }
      return false;
    }
    function hasVisibleMenu(element, container) {
      let el = element;
      while (el !== null) {
        if (el.hasAttribute('data-open')) {
          return true;
        }
        if (el === container) {
          break;
        }
        el = el.parentElement;
      }
      return false;
    }

    // set focus on first focusable element
    setTimeout(function () {
      getFocusableElements()[0].focus();
    }, 1);
    closeElement.on('click', function (e) {
      targetElement.focus();
    });
    $('body').on('keydown', function (e) {
      const isEscPressed = e.key === 'Esc' || e.keyCode === KEYCODE_ESC;
      const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
      if (!isEscPressed && !isTabPressed) {
        return;
      }
      const focusableElements = getFocusableElements(extraFocusableElements);
      const currentSelected = focusableElements.indexOf(document.activeElement);
      let newIndex;
      if (e.shiftKey) {
        newIndex = currentSelected - 1 < 0 ? focusableElements.length - 1 : currentSelected - 1;
      } else {
        newIndex = currentSelected + 1 > focusableElements.length - 1 ? 0 : currentSelected + 1;
      }
      focusableElements[newIndex].focus();
      e.preventDefault();

      // close container element
      if (isEscPressed) {
        closeElement.click();
        targetElement.focus();
      }
    });
  }
}

},{"./utils":10}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class MenuMobileSearch {
  constructor(mobileMenu) {
    this.mobileMenu = mobileMenu;
    this.searchBar = this.mobileMenu.querySelector('.js-search-bar');
    if (this.searchBar) {
      this.isSearchBarTransitioning = false;
      this.searchBar.classList.add('invisible');
      this.getShowSearchBarButton()?.addEventListener('click', this.showSearchBar.bind(this));
      this.getHideSearchBarButton()?.addEventListener('click', this.hideSearchBar.bind(this));
    }
  }
  showSearchBar(clickEvent) {
    clickEvent.preventDefault();
    if (this.isSearchBarTransitioning || this.isSearchBarVisible()) {
      return;
    }
    this.searchBar.classList.add('active');
    this.searchBar.classList.remove('invisible');
    this.setAriaExpanded(true);
    this.fadeOutNonSearchControls();
    this.getShowSearchBarButton().classList.add('invisible');
    this.isSearchBarTransitioning = true;
    this.resetTransitioningFlagOnTransitionEnd(() => this.getSearchBarInput().focus());
  }
  hideSearchBar(clickEvent) {
    clickEvent.preventDefault();
    if (this.isSearchBarTransitioning || !this.isSearchBarVisible()) {
      return;
    }
    this.setAriaExpanded(false);
    this.fadeInNonSearchControls();
    this.isSearchBarTransitioning = true;
    this.resetTransitioningFlagOnTransitionEnd(() => this.getShowSearchBarButton().focus());
    this.getShowSearchBarButton().classList.remove('invisible');
    this.searchBar.classList.remove('active');
    this.searchBar.classList.add('invisible');
  }
  fadeOutNonSearchControls() {
    // `transparent` controls the opacity (for the fade effect) and `invisible` is a bootstrap utility to let screen readers ignore the element.
    for (const control of this.getNonSearchControls()) {
      control.classList.add('transparent');
      control.classList.remove('active');
      control.addEventListener('transitionend', () => control.classList.add('invisible'), {
        once: true
      });
    }
  }
  fadeInNonSearchControls() {
    for (const control of this.getNonSearchControls()) {
      control.classList.remove('transparent');
      control.classList.remove('invisible');
    }
  }
  setAriaExpanded(expanded) {
    this.getShowSearchBarButton().setAttribute('aria-expanded', expanded ? 'true' : 'false');
    this.getHideSearchBarButton().setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }
  resetTransitioningFlagOnTransitionEnd() {
    let additionalHandler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    const resetFlagHandler = event => {
      if (event.propertyName !== 'transform') {
        // Focusing (and blurring) the input field runs a transition on box-shadow.
        // We're only interested in the end of the `transform` transition, so ignore everything else.
        return;
      }
      this.isSearchBarTransitioning = false;
      if (typeof additionalHandler === 'function') {
        additionalHandler();
      }
      this.searchBar.removeEventListener('transitionend', resetFlagHandler);
    };
    this.searchBar.addEventListener('transitionend', resetFlagHandler);
  }
  isSearchBarVisible() {
    return this.searchBar.classList.contains('active');
  }
  getNonSearchControls() {
    return Array.from(this.mobileMenu.querySelectorAll('.js-menu-bottom-item'));
  }
  getShowSearchBarButton() {
    return this.mobileMenu.querySelector('.js-navbar-toggler-search');
  }
  getHideSearchBarButton() {
    return this.mobileMenu.querySelector('.js-form-search-close-btn');
  }
  getSearchBarInput() {
    return this.mobileMenu.querySelector('.js-form-search-input');
  }
}
exports.default = MenuMobileSearch;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = _interopRequireDefault(require("./utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
-----------------------------------------------------------
 MOBILE DROPDOWN FUNCTIONALITY
-----------------------------------------------------------
* These functions drive the dropdown functionality and styling of the dropdown menu on mobile
* Setting a noscroll on the html when the dropdown is not collapsed. For this to work the collapsed
* class needs to be added to the HTML template.
*/

if ((0, _utils.default)('js-navbar-toggler-dropdown')) {
  $('body').on('click', '.js-navbar-toggler-dropdown', function () {
    noscrollToggle(this);
  });
  function noscrollToggle(e) {
    const html = $('html');
    let element = $(e).hasClass('collapsed');
    if (element) {
      hideChatButton();
      html.addClass("noscroll");
    } else {
      showChatButton();
      html.removeClass("noscroll");
      html.removeAttr("class");
    }
  }

  /*
  -----------------------------------------------------------
  HIDING CHAT BUTTON
  -----------------------------------------------------------
  * These functions hide the chat button
  */

  /* function for hiding the cobrowser chat button on mobile */
  function hideChatButton() {
    $('.__cb_plugin_standard_button').css('display', 'none');
  }

  /* function for showing the cobrowser chat button on mobile */
  function showChatButton() {
    $('.__cb_plugin_standard_button').css('display', 'block');
  }
}

/*
-----------------------------------------------------------
 MOBILE FLYOUT FUNCTIONALITY
-----------------------------------------------------------
*/

/*
 * Slinky (Modified by Kadaster)
 *
 * @author Ali Zahid <ali.zahid@live.com>
 * @author Kadaster
 *
 * MIT License
 *
 * Copyright (c) 2019 Ali Zahid
 * Copyright (c) 2020 Kadaster
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
class MenuMobile {
  constructor(element) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.settings = {
      ...this.options,
      ...options
    };
    this._init(element);
  }

  // default options
  get options() {
    return {
      resize: true,
      speed: 300,
      theme: '',
      title: false
    };
  }
  _init(element) {
    this.menu = jQuery(element);
    this.base = this.menu.children().first();
    const {
      menu,
      settings
    } = this;
    this._transition(settings.speed);
    jQuery('li > a', menu).wrapInner('<span class="menu-dropdown-link-text">');
    jQuery('li > a:not([href])').attr('href', 'javascript:void(0)');

    // create next arrows
    jQuery('a + ul', menu).prev().addClass('next').attr('aria-expanded', 'false').append('<span class="far fa-angle-right icon-suffix menu-dropdown-link-icon"></span>');

    //create .header for back buttons
    const header = jQuery('<li>').addClass('header');
    jQuery('li > ul', menu).prepend(header);
    jQuery('.menu-mobile-dropdown-menu').attr('data-open', 'true');

    // add back buttons to .header
    const back = jQuery('<a>').prop('href', '#').addClass('back').addClass('dropdown-menu-link').append('<span><span class="far fa-angle-left icon-prefix"></span>Terug</span>');
    jQuery('.header', menu).prepend(back);

    // set menu title when true in settings
    if (settings.title) {
      jQuery('li > ul', menu).each((index, element) => {
        const label = jQuery(element).parent().find('a').first().text();
        if (label) {
          const title = jQuery('<header>').addClass('title').text(label);
          jQuery('> .header', element).append(title);
        }
      });
    }

    // called when specified MenuMobile is delivered to the window
    this._addListeners();
    this._jumpToInitial();
  }
  _addListeners() {
    const {
      menu,
      settings
    } = this;
    jQuery('a', menu).on('click', e => {
      if (this._clicked + settings.speed > Date.now()) {
        return false;
      }
      this._clicked = Date.now();
      const link = jQuery(e.currentTarget);

      // Remove all data-opens of the whole menu
      menu.find('.dropdown-submenu, .menu-mobile-dropdown-menu').removeAttr('data-open');

      // Only set your own submenu as open
      const subMenu = link.siblings('.dropdown-submenu');
      subMenu.attr('data-open', 'true');

      // Removed the following if because a link in the mobile menu may refer to an id on the same page
      // link.attr('href').indexOf('#') === 0 ||
      if (link.hasClass('next') || link.hasClass('back')) {
        e.preventDefault();
      }
      if (link.hasClass('next')) {
        menu.find('.active').removeClass('active');
        link.attr('aria-expanded', 'true');
        link.next().show().addClass('active');
        this._move(1, () => {
          const subMenu = link.siblings('.dropdown-submenu');
          subMenu.attr('data-open', 'true');
          subMenu.find('a').first()?.focus();
        });
        if (settings.resize) {
          this._resize(link.next());
        }
      } else if (link.hasClass('back')) {
        const self = link.closest('.dropdown-submenu, .menu-mobile-dropdown-menu');
        const parentMenu = self.parent().closest('.dropdown-submenu, .menu-mobile-dropdown-menu');
        parentMenu.attr('data-open', 'true');
        self.siblings('a').first()?.focus();
        this._move(-1, () => {
          menu.find('.active').removeClass('active');
          link.parent().parent().prev().attr('aria-expanded', 'false');
          link.parent().parent().hide().parentsUntil(menu, 'ul').first().addClass('active');
        });
        if (settings.resize) {
          this._resize(link.parent().parent().parentsUntil(menu, 'ul'));
        }
      }
    });
  }

  //makes sure menu is on initial state on page load
  _jumpToInitial() {
    const {
      menu,
      settings
    } = this;

    // get initial active
    const active = menu.find('.active');
    if (active.length > 0) {
      // remove initial active
      active.removeClass('active');

      // jump without animation
      this.jump(active, false);
    }

    // set initial height on the menu
    // to fix the first transition resize bug
    setTimeout(() => menu.height('calc(100% - 130px)'), settings.speed);
  }

  // slide the menu
  _move() {
    let depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
    // don't bother packing if we're not going anywhere
    if (depth === 0) {
      return;
    }
    const {
      settings,
      base
    } = this;

    // get current position from the left
    const left = Math.round(parseInt(base.get(0).style.left)) || 0;

    // set the new position from the left
    base.css('left', `${left - depth * 100}%`);

    // callback after the animation
    if (typeof callback === 'function') {
      setTimeout(callback, settings.speed);
    }
  }

  // resize the menu
  // to match content height
  _resize(content) {
    const {
      menu
    } = this;
    menu.height('calc(100% - 130px)');
  }

  // set the transition speed
  _transition() {
    let speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;
    const {
      menu,
      base
    } = this;
    menu.css('transition-duration', `${speed}ms`);
    base.css('transition-duration', `${speed}ms`);
  }

  // jump to an element
  jump(target) {
    let animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!target) {
      return;
    }
    const {
      menu,
      settings
    } = this;
    const to = jQuery(target);

    // get all current active
    const active = menu.find('.active');

    // how many moves must we jump?
    let count = 0;

    // this many
    // until we reach the parent list
    if (active.length > 0) {
      count = active.parentsUntil(menu, 'ul').length;
    }

    // remove current active
    // hide all lists
    menu.find('ul').removeClass('active').hide();

    // get parent list
    const menus = to.parentsUntil(menu, 'ul');

    // show parent list
    menus.show();

    // show target
    to.show().addClass('active');

    // set transition speed to 0 if no animation
    if (!animate) {
      this._transition(0);
    }

    // make the checkers move
    this._move(menus.length - count);

    // resize menu if need be
    if (settings.resize) {
      this._resize(to);
    }

    // set transition speed to default after transition
    if (!animate) {
      this._transition(settings.speed);
    }
  }

  // go big or go home
  // just go home
  home() {
    let animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const {
      base,
      menu,
      settings
    } = this;

    // set transition speed to 0 if no animation
    if (!animate) {
      this._transition(0);
    }

    // get current active
    const active = menu.find('.active');

    // get all parent lists
    const parents = active.parentsUntil(menu, 'ul');

    // make the move
    this._move(-parents.length, () => {
      // remove the current active
      active.removeClass('active').hide();

      // hide all parents except base
      parents.not(base).hide();
    });

    // resize if need be
    if (settings.resize) {
      this._resize(base);
    }

    // set transition speed back to default
    if (animate === false) {
      this._transition(settings.speed);
    }
  }

  // crush, kill, destroy
  destroy() {
    const {
      base,
      menu
    } = this;

    // remove all headers
    jQuery('.header', menu).remove();

    // remove MobileMenu links
    // and click listeners
    jQuery('a', menu).removeClass('next').off('click');

    // remove inline styles
    menu.css({
      height: '',
      'transition-duration': ''
    });
    base.css({
      left: '',
      'transition-duration': ''
    });

    // remove MobileMenu HTML
    jQuery('li > a > span', menu).contents().unwrap();

    // remove any current active
    menu.find('.active').removeClass('active');

    // remove any MobileMenu style classes
    const styles = menu.attr('class').split(' ');
    styles.forEach(style => {
      if (style.indexOf('slinky') === 0) {
        menu.removeClass(style);
      }
    });

    // reset fields
    const fields = ['settings', 'menu', 'base'];
    fields.forEach(field => delete this[field]);
  }
}

// jQuery plugin
exports.default = MenuMobile;
($ => {
  $.fn.menuMobile = function (options) {
    return new MenuMobile(this, options);
  };
})(jQuery);

},{"./utils":10}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _utils = _interopRequireDefault(require("./utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _default() {
  if (!(0, _utils.default)('js-dropdown')) {
    return;
  }
  setAriaAttributesOnInit();
  $(function () {
    /* Prevent dropdown menu from closing when clicking inside of dropdown or on a menu-link.
    *  (Bootstrap natively closes dropdown on click outside of dropdown element.) */
    document.body.addEventListener('click', event => {
      // Early return means letting the event bubble up, closing the menu

      const dropdownMenu = event.target.closest('.js-dropdown');
      if (!dropdownMenu) {
        // Clicked outside the menu
        return;
      }
      const closeButton = event.target.closest('.close');
      if (closeButton) {
        // Close button clicked
        return;
      }
      const arrowLink = event.target.closest('.dropdown-menu-link');
      if (arrowLink) {
        // Link with arrow clicked - prevent navigating to #
        event.preventDefault();
      }
      event.stopPropagation();
    });
    $('.js-dropdown-link').on('click', function () {
      deactivateFlyouts(this);
      activateFlyout(this);
      resetDropdownMenuHeight();
      handleMenuLinkStyling(this);
      setDropdownMenuHeight();
      handleFlyoutAriaLabels(this);
    });
    $('.dropdown').on('hidden.bs.dropdown', function () {
      resetDropdown();
    });
  });

  /*
  -----------------------------------------------------------
  FLYOUT FUNCTIONALITY
  -----------------------------------------------------------
  * These functions drive the flyout functionality and styling of the dropdown menu
  */

  /* Set the dropdown height to the height of the longest flyout */
  function setDropdownMenuHeight() {
    const dropdown = $('.js-dropdown');
    const activeFlyoutsClass = $('.js-dropdown-flyout:not(.d-none)');

    /* Map all flyout heights and fetch the heighest value to set to .dropdown-menu-container */
    const activeFlyouts = dropdown.find(activeFlyoutsClass).map(function () {
      return this.clientHeight;
    }).get();
    const heighestFltoutHeight = Math.max.apply(Math, activeFlyouts);
    $('.js-dropdown-container').css('height', heighestFltoutHeight);
  }
  function resetDropdownMenuHeight() {
    $('.js-dropdown-container').css('height', 'auto');
  }
  function deactivateFlyouts(e) {
    const dropdown = $('.js-dropdown');
    const parentMenuListItem = $(e).closest('li', dropdown);
    const activeFlyouts = $('.js-dropdown-flyout-next:not(.d-none)');
    const nextActiveFlyouts = parentMenuListItem.siblings().find(activeFlyouts);
    nextActiveFlyouts.addClass('d-none');
  }
  function activateFlyout(e) {
    const nextFlyout = $(e).siblings('.js-dropdown-flyout-next');
    nextFlyout.removeClass('d-none');
  }
  function handleMenuLinkStyling(e) {
    activateMenuItem(e);
    deactivateMenuItems(e);
  }
  function activateMenuItem(e) {
    $(e).addClass('active');
  }
  function deactivateMenuItems(e) {
    const dropdown = $('.js-dropdown');
    const parentMenuListItem = $(e).closest('li', dropdown); /* click is registered on <a> element, need to target parent <li> to access sibling elements */
    const siblings = parentMenuListItem.siblings();
    const menuLinks = siblings.children('.js-dropdown-link');
    menuLinks.removeClass('active');
    siblings.find('.active').removeClass('active');
  }
  function handleFlyoutAriaLabels(e) {
    /* only set aria-expanded = true to elements with a sibling flyout menu */
    if ($(e).hasClass('active') && $(e).siblings('.js-dropdown-flyout').length > 0) {
      e.setAttribute('aria-expanded', 'true');
    }
    const parentMenuLi = $(e).parent();
    const siblingMenusLinks = parentMenuLi.siblings().find('.js-dropdown-link');
    if (siblingMenusLinks.attr('aria-expanded') === 'true') {
      siblingMenusLinks.attr('aria-expanded', 'false');
    }
  }
  function resetAriaLabels() {
    const dropdownMenuLinks = $('body').find('.js-dropdown-container [aria-expanded]');
    $.each(dropdownMenuLinks, function (index, element) {
      element.setAttribute('aria-expanded', 'false');
    });
  }
  function resetDropdown() {
    const dropdown = $('.js-dropdown');
    dropdown.find('.js-dropdown-flyout-next').addClass('d-none');
    dropdown.find('.active').removeClass('active');
    resetDropdownMenuHeight();
    resetAriaLabels();
  }
  function setAriaAttributesOnInit() {
    const dropdownContainer = $('.menu-dropdown-container');
    const allDropdownLinks = dropdownContainer.find('.js-dropdown-link');
    allDropdownLinks.attr('aria-expanded', 'false');
    allDropdownLinks.attr('aria-haspopup', 'true');
  }
}

},{"./utils":10}],9:[function(require,module,exports){
"use strict";

var _utils = _interopRequireDefault(require("./utils"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
if ((0, _utils.default)('js-myk-user-menu-dropdown-toggle')) {
  $('.js-myk-header-profile-menu-btn').on('click', function () {
    $(this).parents('.dropdown').find('button.dropdown-toggle').dropdown('toggle');
  });

  /**
   * Observer watches class changes in the dropdown menu of the user
   * As soon as the dropdown menu is toggled, it triggers the function in the MutationObserver
   * This function makes sure the focus is set on the right element.
   * When the dropdown is not collapsed this is the first menu item
   * When the dropdown is collapsed this is the dropdown button of the closed dropdown
   *
   * @type {MutationObserver}
   */
  var changeFocusOnDropdownToggle = new MutationObserver(function () {
    if ($('.js-myk-user-menu-dropdown').hasClass('show')) {
      $('.js-myk-header-user-menu-item').first().focus();
    } else {
      $('.js-myk-user-menu-dropdown-toggle').focus();
    }
  });
  changeFocusOnDropdownToggle.observe(document.querySelector('.js-myk-user-menu-dropdown'), {
    attributes: true
  });
}

},{"./utils":10}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.needsLoadingById = needsLoadingById;
function _default(elementClass) {
  // When an element with a given class exists on the page (on load), return true
  return document.getElementsByClassName(elementClass).length > 0;
}

/**
 * @param elementId the id to check
 * @returns {boolean} true if the given element exists on the page
 */
function needsLoadingById(elementId) {
  return !!document.getElementById(elementId);
}

},{}],11:[function(require,module,exports){
"use strict";

/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages = function () {
  'use strict';

  var OFI = 'bfred-it:object-fit-images';
  var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
  var testImg = typeof Image === 'undefined' ? {
    style: {
      'object-position': 1
    }
  } : new Image();
  var supportsObjectFit = ('object-fit' in testImg.style);
  var supportsObjectPosition = ('object-position' in testImg.style);
  var supportsOFI = ('background-size' in testImg.style);
  var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
  var nativeGetAttribute = testImg.getAttribute;
  var nativeSetAttribute = testImg.setAttribute;
  var autoModeEnabled = false;
  function createPlaceholder(w, h) {
    return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E";
  }
  function polyfillCurrentSrc(el) {
    if (el.srcset && !supportsCurrentSrc && window.picturefill) {
      var pf = window.picturefill._;
      // parse srcset with picturefill where currentSrc isn't available
      if (!el[pf.ns] || !el[pf.ns].evaled) {
        // force synchronous srcset parsing
        pf.fillImg(el, {
          reselect: true
        });
      }
      if (!el[pf.ns].curSrc) {
        // force picturefill to parse srcset
        el[pf.ns].supported = false;
        pf.fillImg(el, {
          reselect: true
        });
      }

      // retrieve parsed currentSrc, if any
      el.currentSrc = el[pf.ns].curSrc || el.src;
    }
  }
  function getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while ((parsed = propRegex.exec(style)) !== null) {
      props[parsed[1]] = parsed[2];
    }
    return props;
  }
  function setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = createPlaceholder(width || 1, height || 0);

    // Only set placeholder if it's different
    if (nativeGetAttribute.call(img, 'src') !== placeholder) {
      nativeSetAttribute.call(img, 'src', placeholder);
    }
  }
  function onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) {
      callback(img);
    } else {
      setTimeout(onImageReady, 100, img, callback);
    }
  }
  function fixOne(el) {
    var style = getStyle(el);
    var ofi = el[OFI];
    style['object-fit'] = style['object-fit'] || 'fill'; // default value

    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
      // fill is the default behavior so no action is necessary
      if (style['object-fit'] === 'fill') {
        return;
      }

      // Where object-fit is supported and object-position isn't (Safari < 10)
      if (!ofi.skipTest &&
      // unless user wants to apply regardless of browser support
      supportsObjectFit &&
      // if browser already supports object-fit
      !style['object-position'] // unless object-position is used
      ) {
        return;
      }
    }

    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
      ofi.img = new Image(el.width, el.height);
      ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
      ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

      // preserve for any future cloneNode calls
      // https://github.com/bfred-it/object-fit-images/issues/53
      nativeSetAttribute.call(el, "data-ofi-src", el.src);
      if (el.srcset) {
        nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
      }
      setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

      // remove srcset because it overrides src
      if (el.srcset) {
        el.srcset = '';
      }
      try {
        keepSrcUsable(el);
      } catch (err) {
        if (window.console) {
          console.warn('https://bit.ly/ofi-old-browser');
        }
      }
    }
    polyfillCurrentSrc(ofi.img);
    el.style.backgroundImage = "url(\"" + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + "\")";
    el.style.backgroundPosition = style['object-position'] || 'center';
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundOrigin = 'content-box';
    if (/scale-down/.test(style['object-fit'])) {
      onImageReady(ofi.img, function () {
        if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
          el.style.backgroundSize = 'contain';
        } else {
          el.style.backgroundSize = 'auto';
        }
      });
    } else {
      el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
    }
    onImageReady(ofi.img, function (img) {
      setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
  }
  function keepSrcUsable(el) {
    var descriptors = {
      get: function get(prop) {
        return el[OFI].img[prop ? prop : 'src'];
      },
      set: function set(value, prop) {
        el[OFI].img[prop ? prop : 'src'] = value;
        nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
        fixOne(el);
        return value;
      }
    };
    Object.defineProperty(el, 'src', descriptors);
    Object.defineProperty(el, 'currentSrc', {
      get: function () {
        return descriptors.get('currentSrc');
      }
    });
    Object.defineProperty(el, 'srcset', {
      get: function () {
        return descriptors.get('srcset');
      },
      set: function (ss) {
        return descriptors.set(ss, 'srcset');
      }
    });
  }
  function hijackAttributes() {
    function getOfiImageMaybe(el, name) {
      return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
    }
    if (!supportsObjectPosition) {
      HTMLImageElement.prototype.getAttribute = function (name) {
        return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
      };
      HTMLImageElement.prototype.setAttribute = function (name, value) {
        return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
      };
    }
  }
  function fix(imgs, opts) {
    var startAutoMode = !autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || 'img';
    if (supportsObjectPosition && !opts.skipTest || !supportsOFI) {
      return false;
    }

    // use imgs as a selector or just select all images
    if (imgs === 'img') {
      imgs = document.getElementsByTagName('img');
    } else if (typeof imgs === 'string') {
      imgs = document.querySelectorAll(imgs);
    } else if (!('length' in imgs)) {
      imgs = [imgs];
    }

    // apply fix to all
    for (var i = 0; i < imgs.length; i++) {
      imgs[i][OFI] = imgs[i][OFI] || {
        skipTest: opts.skipTest
      };
      fixOne(imgs[i]);
    }
    if (startAutoMode) {
      document.body.addEventListener('load', function (e) {
        if (e.target.tagName === 'IMG') {
          fix(e.target, {
            skipTest: opts.skipTest
          });
        }
      }, true);
      autoModeEnabled = true;
      imgs = 'img'; // reset to a generic selector for watchMQ
    }

    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) {
      window.addEventListener('resize', fix.bind(null, imgs, {
        skipTest: opts.skipTest
      }));
    }
  }
  fix.supportsObjectFit = supportsObjectFit;
  fix.supportsObjectPosition = supportsObjectPosition;
  hijackAttributes();
  return fix;
}();

},{}]},{},[11,4]);
